<template>
	<b-modal
		ref="inseminations-by-period-modal"
		size="lg"
		hide-footer
		@hidden="handleCloseModal"
		scrollable
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div class="font-weight-bold">
					Inseminaciones | Periodo:
					<span>{{ period.period_start | myGlobalDayShort }}</span>
					-
					<span v-if="period.period_end">{{ period.period_end | myGlobalDayShort }}</span>
					<span v-else>SIN FINALIZAR</span>
				</div>
				<div style="display: flex; gap: 0.5rem">
					<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
						<FeatherIcon icon="XIcon" />
					</b-button>
				</div>
			</div>
		</template>
		<b-overlay :show="isLoading">
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in fields" :key="field.key" :class="field.class">
							{{ field.label }}
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="inseminations.length > 0">
						<b-tr v-for="(insemination, index) in inseminations" :key="index">
							<b-td class="text-center">
								<b-button variant="flat-info" v-b-tooltip.hover.top.html="getTooltipInfo(insemination)">
									{{ insemination.qty }}
								</b-button>
							</b-td>
							<b-td class="text-center">
								<div>{{ insemination.name }}</div>
							</b-td>
							<b-td class="text-center">
								<div>{{ insemination.created_at | myGlobalDayShort }}</div>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="inseminations.length === 0">
						<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
	</b-modal>
</template>

<script>
import PosturePeriodsService from "@/services/encaste/posturas/posture-periods.service.js"
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
export default {
	name: "InseminationsByPeriodModal",
	props: {
		period: {
			type: Object,
			required: true,
		},
	},
	components: { SpecimenPlate },
	data: () => ({
		isLoading: false,
		fields: [
			{ key: "madrillas", label: "Madrillas", class: "text-center" },
			{ key: "name", label: "Inseminado por", class: "text-center" },
			{ key: "created_at", label: "Fecha", class: "text-center" },
		],
		inseminations: [],
	}),
	computed: {},
	methods: {
		getTooltipInfo(insemination) {
			return insemination.madrillas.map((m) => `<div>${m.plate}(${m.alias})</div>`).join("")
		},
		handleCloseModal() {
			this.$emit("refresh")
			this.$emit("close")
		},
		async getRows() {
			try {
				this.isLoading = true
				const { data } = await PosturePeriodsService.getInseminationsByPeriod(this.period.id)
				this.inseminations = data || []
			} catch (error) {
				console.error("Error fetching average weights report drafts:", error)
			} finally {
				this.isLoading = false
			}
		},
	},

	async mounted() {
		await this.getRows()
		this.$refs["inseminations-by-period-modal"].toggle()
	},
}
</script>
